import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页', end: true },
  { to: '/incidents', label: '事件库', end: false },
  { to: '/topics', label: '风险分类', end: false },
  { to: '/about', label: '关于我们', end: false },
  { to: '/contact', label: '报料联系', end: false },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="hidden border-b border-background-200/70 bg-background-100/70 md:block">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-1.5 text-xs text-foreground-600">
          <p className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-radar-line text-[13px] text-primary-600"></i>
            </span>
            安全事件与隐私风险情报，每个工作日更新
          </p>
          <p className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-mail-line text-[13px]"></i>
              </span>
              报料：report@heiliaoleida.com
            </span>
            <span className="flex items-center gap-1.5 text-secondary-700">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-shield-check-line text-[13px]"></i>
              </span>
              内容以公开信息为基础整理
            </span>
          </p>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6 md:py-4">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-radar-line text-xl"></i>
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-lg font-bold tracking-tight text-foreground-950">
              黑料雷达
            </span>
            <span className="block text-[10px] tracking-[0.18em] text-foreground-500">
              RISK INTEL
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `relative rounded-md px-3.5 py-2 text-sm transition-colors ${
                  isActive
                    ? 'text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute inset-x-3.5 -bottom-0.5 h-0.5 rounded-full bg-primary-500"></span>
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/incidents"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-foreground-300 hover:bg-background-100 md:flex"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-search-line text-sm"></i>
            </span>
            检索事件
          </Link>
          <Link
            to="/contact"
            className="hidden whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 md:block"
          >
            我要报料
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col px-4 py-2" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `border-b border-background-100 py-3 text-sm last:border-0 ${
                    isActive ? 'text-primary-700' : 'text-foreground-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-3 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              我要报料
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}